import React from 'react';
import '../../sass/components/_components.signup.scss';
import '../../sass/components/_components.marketoSignUp.scss';
import MarketoFormComponent from './marketoFormComponent';

const MarketoSignUp = () => {
    return (
        <div className="cp-marketoSignup">
            <div className="cp-marketoSignup__inner l--maxWidthContent l--flex">
                <div className="cp-marketoSignup__left">
                    {process.env.GATSBY_LANG === "de" ?
                        <h3>Abonniere unseren Newsletter</h3>
                        :
                        <h3>Join our newsletter</h3>
                    }
                    {process.env.GATSBY_LANG === "de" ?
                        <p>Abonniere, um wöchentlich eine Übersicht unserer neuesten Blog-Beiträge zu erhalten</p>
                        :
                        <p>Subscribe to get a weekly digest of our latest blog posts</p>
                    }
                </div>
                <div className="cp-marketoSignup__right">
                    <MarketoFormComponent formId="3176" />
                </div>
            </div>
        </div>
    );
}

export default MarketoSignUp;